import { useAppStore } from "../../store/appStore";
import { LoadingWithLabel } from "../Loading";

const Top30TrendLoading = () => {
	const listOption = useAppStore((state) => state.listOption);
	const queryTop14TrendsProgress = useAppStore(
		(state) => state.queryTop14TrendsProgress
	);
	return (
		<LoadingWithLabel
			value={
				listOption === "m"
					? queryTop14TrendsProgress.m
					: queryTop14TrendsProgress.f
			}
		/>
	);
};

export default Top30TrendLoading;
